import { FC } from 'react';
import { Container, Stack, Typography } from '@mui/material';
import { StaffForm } from 'src/components/organisms/staff/form';
import Page from 'src/components/molecules/page';

export const StaffEditPage: FC = () => {
  const title = 'スタッフ編集';

  return (
    <Page title={title}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            {title}
          </Typography>
        </Stack>
        <StaffForm />
      </Container>
    </Page>
  );
};
